<div class="container-fluid">
  <!-- Production Analytics -->
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 animate-fade-in shadow-none">
        <div class="card-body p-3">
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-4">
            <div>
              <h1 class="card-title mb-1">Production Analytics</h1>
              <span class="sub-text">Monitor production trends and output insights</span>
            </div>
            <!--            <button class="btn btn-primary">-->
            <!--              <i class="bi bi-download"></i>-->
            <!--              <span>Export Report</span>-->
            <!--            </button>-->
          </div>

          <div class="bg-light p-3 border mb-4">
            <div class="row g-3">
              <div class="col-lg-4 col-md-8">
                <label class="form-label small fw-bold text-muted">Select Product</label>
                <ng-select
                  placeholder="All Products"
                  [items]="productList"
                  [(ngModel)]="selectedProduct"
                  bindValue="id"
                  bindLabel="name"
                  [clearable]="true"
                  [searchable]="true" />
              </div>
              <div class="col-lg-5 col-md-8">
                <label class="form-label small fw-bold text-muted">Time Period</label>
                <div class="input-group">
                  <input type="date" class="form-control" [(ngModel)]="startDate" />
                  <span class="input-group-text bg-white text-muted small">to</span>
                  <input type="date" class="form-control" [(ngModel)]="endDate" />
                </div>
              </div>
              <div class="col-lg-3 col-md-8">
                <div class="row">
                  <div class="col-5">
                    <label class="form-label small fw-bold text-muted">Year</label>
                    <ng-select
                      [items]="yearsList"
                      [(ngModel)]="selectedYear"
                      [clearable]="false"
                      [searchable]="false" />
                  </div>
                  <div class="col-7">
                    <label class="form-label small fw-bold text-muted">Filters</label>
                    <button class="btn btn-primary w-100" (click)="applyFilters()">
                      <i class="bi bi-funnel"></i>
                      <span>Filter</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="chart-container-bg p-3 bg-white border" style="min-height: 450px">
            @if (isDashboardDataLoading) {
              <app-loading-spinner></app-loading-spinner>
            } @else {
              @if (productionEntries && productionEntries.length > 0) {
                <div class="animate-fade-in">
                  <app-line-chart [productionEntries]="productionEntries"></app-line-chart>
                </div>
              } @else {
                <div class="d-flex flex-column align-items-center justify-content-center text-muted h-100 py-5">
                  <div class="p-4 mb-4">
                    <i class="bi bi-bar-chart-line text-muted" style="font-size: 3rem"></i>
                  </div>
                  <h5 class="fw-bold text-dark mb-1">No Data Found</h5>
                  <p class="mb-0 text-center max-w-400">
                    We couldn't find any production entries for the selected filters. Try broadening your date range or
                    selecting a different product.
                  </p>
                </div>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Today's Attendance -->
  <div class="row mt-4">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 animate-fade-in shadow-none">
        <div class="card-body p-3">
          <div class="d-flex flex-row justify-content-between align-items-center mb-4">
            <div>
              <h2 class="card-title mb-1">Today's Attendance</h2>
              <span class="sub-text">Real-time check-in status of all employees</span>
            </div>
            @if (employeesTodayAttendance.length > 0) {
              <span class="app-badge badge-primary">{{ employeesTodayAttendance.length }} Total</span>
            }
          </div>

          <div class="table-container bg-white border">
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0">
                <thead class="bg-light">
                  <tr>
                    <th class="px-3 py-3 border-bottom-0 text-muted small fw-bold uppercase">Employee</th>
                    <th class="px-3 py-3 border-bottom-0 text-muted small fw-bold uppercase">Status</th>
                    <th class="px-3 py-3 border-bottom-0 text-muted small fw-bold uppercase">Check-in Time</th>
                    <th class="px-3 py-3 border-bottom-0 text-muted small fw-bold uppercase">Location</th>
                  </tr>
                </thead>
                <tbody>
                  @if (isAttendanceLoading) {
                    <tr>
                      <td colspan="4" class="text-center py-5">
                        <app-loading-spinner></app-loading-spinner>
                      </td>
                    </tr>
                  } @else {
                    @for (emp of pagedEmployees; track emp.id) {
                      <tr class="animate-fade-in">
                        <td class="px-3 py-3">
                          <div class="d-flex align-items-center">
                            <img
                              [src]="emp.profile_image || getDefaultProfilePicUrl(emp.first_name, emp.last_name)"
                              alt="{{ emp.first_name }} {{ emp.last_name }}"
                              class="rounded-circle me-3"
                              style="width: 38px; height: 38px; object-fit: cover"
                              (error)="handleImageError($event)" />
                            <div class="d-flex flex-column">
                              <span class="fw-bold text-dark">{{ emp.first_name }} {{ emp.last_name }}</span>
                              <span class="text-muted small">{{ emp.email }}</span>
                            </div>
                          </div>
                        </td>
                        <td class="px-3 py-3">
                          @if (emp.status === 'check-in') {
                            <span class="app-badge badge-success">Checked In</span>
                          } @else if (emp.status === 'check-out') {
                            <span class="app-badge badge-danger">Checked Out</span>
                          } @else {
                            <span class="app-badge badge-secondary">Yet to Check In</span>
                          }
                        </td>
                        <td class="px-3 py-3">
                          <span class="text-dark">
                            {{ convertUTCtoIST(emp.time!) }}
                          </span>
                        </td>
                        <td class="px-3 py-3">
                          <div class="d-flex align-items-center text-muted small">
                            <i class="bi bi-geo-alt me-1"></i>
                            <span class="text-truncate d-inline-block" style="max-width: 250px" [title]="emp.location">
                              {{ emp.location || 'Not Available' }}
                            </span>
                          </div>
                        </td>
                      </tr>
                    } @empty {
                      <tr>
                        <td colspan="4" class="text-center py-5">
                          <div class="d-flex flex-column align-items-center justify-content-center text-muted">
                            <i class="bi bi-people mb-2" style="font-size: 2rem"></i>
                            <p class="mb-0">No attendance records found for today.</p>
                          </div>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-4">
            <app-pagination
              [currentPage]="attendanceCurrentPage"
              [totalCount]="employeesTodayAttendance.length"
              [pageSize]="attendancePageSize"
              [hasNextPage]="attendanceCurrentPage * attendancePageSize < employeesTodayAttendance.length"
              [hasPreviousPage]="attendanceCurrentPage > 1"
              (pageChange)="onAttendancePageChange($event)"></app-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Day-wise Snapshot ──────────────────────────────────────────────────── -->
  <div class="row mt-4">
    <div class="col-12 px-0">
      <!-- Snapshot header banner -->
      <div class="card card-body">
        <div class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
          <div>
            <h2 class="card-title mb-1">Day-wise Snapshot</h2>
            <div class="snapshot-subtitle">Orders · Payments · Purchases · Pending fulfillment</div>
          </div>
          <div class="date-pill">
            <i class="bi bi-calendar3"></i>
            <input type="date" [(ngModel)]="snapshotDate" (change)="onDateChange()" />
            @if (isSnapshotLoading) {
              <span
                class="spinner-border spinner-border-sm text-secondary"
                style="width: 14px; height: 14px; border-width: 2px"></span>
            }
          </div>
        </div>

        @if (isDashboardDataLoading && !summary) {
          <app-loading-spinner></app-loading-spinner>
        } @else if (summary) {
          <!-- 4 summary cards -->
          <div class="row g-3">
            <div class="col-lg-3 col-md-6">
              <div
                class="snapshot-stat-card card-orders"
                [class.active]="openSection === 'orders'"
                (click)="toggleSection('orders')">
                <div class="d-flex justify-content-between align-items-start mb-3">
                  <div class="stat-icon icon-orders rounded"><i class="bi bi-bag-check"></i></div>
                  <i class="bi bi-chevron-right stat-chevron mt-1"></i>
                </div>
                <div class="stat-label">Today's Orders</div>
                <div class="stat-value">{{ summary.today_orders.count }}</div>
                <div class="stat-sub">{{ summary.today_orders.total_boxes }} boxes ordered</div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div
                class="snapshot-stat-card card-payments"
                [class.active]="openSection === 'payments'"
                (click)="toggleSection('payments')">
                <div class="d-flex justify-content-between align-items-start mb-3">
                  <div class="stat-icon icon-payments rounded"><i class="bi bi-wallet2"></i></div>
                  <i class="bi bi-chevron-right stat-chevron mt-1"></i>
                </div>
                <div class="stat-label">Today's Payments</div>
                <div class="stat-value" style="font-size: 1.35rem">
                  ₹{{ summary.today_payments.total_amount | number: '1.0-0' }}
                </div>
                <div class="stat-sub">{{ summary.today_payments.count }} entries</div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div
                class="snapshot-stat-card card-purchases"
                [class.active]="openSection === 'purchases'"
                (click)="toggleSection('purchases')">
                <div class="d-flex justify-content-between align-items-start mb-3">
                  <div class="stat-icon icon-purchases rounded"><i class="bi bi-box-seam"></i></div>
                  <i class="bi bi-chevron-right stat-chevron mt-1"></i>
                </div>
                <div class="stat-label">Today's Purchases</div>
                <div class="stat-value" style="font-size: 1.35rem">
                  ₹{{ summary.today_purchases.total_cost | number: '1.0-0' }}
                </div>
                <div class="stat-sub">{{ summary.today_purchases.count }} purchase orders</div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div
                class="snapshot-stat-card card-pending"
                [class.active]="openSection === 'pending'"
                (click)="toggleSection('pending')">
                <div class="d-flex justify-content-between align-items-start mb-3">
                  <div class="stat-icon icon-pending rounded"><i class="bi bi-clock-history"></i></div>
                  <i class="bi bi-chevron-right stat-chevron mt-1"></i>
                </div>
                <div class="stat-label">Pending Orders</div>
                <div class="stat-value">{{ summary.pending_orders.count }}</div>
                <div class="stat-sub">{{ summary.pending_orders.total_pending_boxes }} boxes pending</div>
              </div>
            </div>
          </div>

          <!-- ── 1. Today's Orders ─────────────────────────────────────────── -->
          @if (openSection === 'orders') {
            <div class="card border-0 shadow-sm mb-3 animate-fade-in">
              <div class="card-header bg-white d-flex justify-content-between align-items-center py-3">
                <span class="fw-semibold">Today's Orders</span>
                <button class="btn btn-link btn-sm p-0 text-muted" (click)="toggleSection('orders')">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
              <div class="card-body p-0">
                @if (summary.today_orders.by_company.length > 0) {
                  <div class="px-4 pt-3 pb-2 border-bottom">
                    <p class="text-muted small fw-bold mb-2">By Company</p>
                    <div class="d-flex flex-column gap-2">
                      @for (bc of summary.today_orders.by_company; track bc.company) {
                        <div class="d-flex align-items-center gap-2">
                          <span class="text-muted small" style="min-width: 100px">{{ bc.company }}</span>
                          <div class="flex-grow-1 bg-light rounded-pill overflow-hidden" style="height: 10px">
                            <div
                              class="bg-primary rounded-pill h-100"
                              [style.width.%]="(bc.total_boxes / maxByCompanyBoxes()) * 100"></div>
                          </div>
                          <span class="text-muted small font-monospace">
                            {{ bc.total_boxes }} boxes ({{ bc.count }})
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                }
                <div class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="bg-light">
                      <tr>
                        <th class="border-0">Order No.</th>
                        <th class="border-0">Company</th>
                        <th class="border-0">Dealer</th>
                        <th class="border-0">Employee</th>
                        <th class="border-0 text-end">Boxes</th>
                        <th class="border-0 text-end">Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (o of summary.today_orders.orders; track o.id) {
                        <tr>
                          <td class="font-monospace fw-medium">{{ o.order_number }}</td>
                          <td>{{ o.company }}</td>
                          <td>{{ o.dealer_name }}</td>
                          <td>{{ o.employee_name }}</td>
                          <td class="text-end">{{ o.total_boxes }}</td>
                          <td class="text-end text-muted small">{{ moment(o.created_at).format('hh:mm A') }}</td>
                        </tr>
                      } @empty {
                        <tr>
                          <td colspan="6" class="text-center text-muted py-4">No orders for this date.</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }

          <!-- ── 2. Today's Payments ───────────────────────────────────────── -->
          @if (openSection === 'payments') {
            <div class="card border-0 shadow-sm mb-3 animate-fade-in">
              <div class="card-header bg-white d-flex justify-content-between align-items-center py-3">
                <span class="fw-semibold">Today's Payments</span>
                <button class="btn btn-link btn-sm p-0 text-muted" (click)="toggleSection('payments')">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
              <div class="card-body p-0">
                @if (summary.today_payments.by_payment_type.length > 0) {
                  <div class="px-4 pt-3 pb-2 border-bottom">
                    <p class="text-muted small fw-bold mb-2">By Payment Type</p>
                    <div class="d-flex flex-column gap-2">
                      @for (bp of summary.today_payments.by_payment_type; track bp.payment_type) {
                        <div class="d-flex align-items-center gap-2">
                          <span class="text-muted small" style="min-width: 100px">
                            {{ bp.payment_type | titlecase }}
                          </span>
                          <div class="flex-grow-1 bg-light rounded-pill overflow-hidden" style="height: 10px">
                            <div
                              class="bg-success rounded-pill h-100"
                              [style.width.%]="(bp.total / maxByPaymentTotal()) * 100"></div>
                          </div>
                          <span class="text-muted small font-monospace">
                            ₹{{ bp.total | number: '1.0-0' }} ({{ bp.count }})
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                }
                <div class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="bg-light">
                      <tr>
                        <th class="border-0">Dealer</th>
                        <th class="border-0">Employee</th>
                        <th class="border-0 text-end">Amount</th>
                        <th class="border-0">Type</th>
                        <th class="border-0">Reference</th>
                        <th class="border-0">Company</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (p of summary.today_payments.payments; track p.id) {
                        <tr>
                          <td>{{ p.dealer_name }}</td>
                          <td>{{ p.employee_name }}</td>
                          <td class="text-end font-monospace">₹{{ p.received_amount | number: '1.0-0' }}</td>
                          <td>
                            <span class="app-badge badge-soft-primary">{{ p.payment_type | titlecase }}</span>
                          </td>
                          <td class="text-muted small">{{ p.reference_number || '—' }}</td>
                          <td>{{ p.company }}</td>
                        </tr>
                      } @empty {
                        <tr>
                          <td colspan="6" class="text-center text-muted py-4">No payments for this date.</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }

          <!-- ── 3. Today's Purchases ──────────────────────────────────────── -->
          @if (openSection === 'purchases') {
            <div class="card border-0 shadow-sm mb-3 animate-fade-in">
              <div class="card-header bg-white d-flex justify-content-between align-items-center py-3">
                <span class="fw-semibold">Today's Purchases</span>
                <button class="btn btn-link btn-sm p-0 text-muted" (click)="toggleSection('purchases')">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="bg-light">
                      <tr>
                        <th class="border-0">PO No.</th>
                        <th class="border-0">Supplier</th>
                        <th class="border-0">Warehouse</th>
                        <th class="border-0 text-end">Cost</th>
                        <th class="border-0 text-center">Payment</th>
                        <th class="border-0 text-center">Approval</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (pu of summary.today_purchases.purchases; track pu.id) {
                        <tr>
                          <td class="font-monospace fw-medium">{{ pu.po_number }}</td>
                          <td>{{ pu.supplier_name }}</td>
                          <td>{{ pu.warehouse }}</td>
                          <td class="text-end font-monospace">₹{{ pu.total_cost | number: '1.0-0' }}</td>
                          <td class="text-center">
                            <span
                              class="app-badge"
                              [class.badge-success]="pu.payment_status === 'paid'"
                              [class.badge-warning]="pu.payment_status === 'partial'"
                              [class.badge-secondary]="pu.payment_status === 'pending'">
                              {{ pu.payment_status | titlecase }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span
                              class="app-badge"
                              [class.badge-success]="pu.approval_status === 'approved'"
                              [class.badge-warning]="pu.approval_status === 'pending'"
                              [class.badge-danger]="pu.approval_status === 'rejected'">
                              {{ pu.approval_status | titlecase }}
                            </span>
                          </td>
                        </tr>
                      } @empty {
                        <tr>
                          <td colspan="6" class="text-center text-muted py-4">No purchases for this date.</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }

          <!-- ── 4. Pending Orders ──────────────────────────────────────────── -->
          @if (openSection === 'pending') {
            <div class="card border-0 shadow-sm mb-3 animate-fade-in">
              <div class="card-header bg-white d-flex justify-content-between align-items-center py-3">
                <span class="fw-semibold">Pending Orders</span>
                <button class="btn btn-link btn-sm p-0 text-muted" (click)="toggleSection('pending')">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="bg-light">
                      <tr>
                        <th class="border-0">Order No.</th>
                        <th class="border-0">Company</th>
                        <th class="border-0">Dealer</th>
                        <th class="border-0">Employee</th>
                        <th class="border-0 text-end">Total Boxes</th>
                        <th class="border-0 text-end">Pending</th>
                        <th class="border-0 text-end">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (po of summary.pending_orders.orders; track po.id) {
                        <tr>
                          <td class="font-monospace fw-medium">{{ po.order_number }}</td>
                          <td>{{ po.company }}</td>
                          <td>{{ po.dealer_name }}</td>
                          <td>{{ po.employee_name }}</td>
                          <td class="text-end">{{ po.total_boxes }}</td>
                          <td class="text-end">
                            <span class="fw-semibold text-danger">{{ po.pending_boxes }}</span>
                          </td>
                          <td class="text-end text-muted small">{{ moment(po.created_at).format('DD MMM YYYY') }}</td>
                        </tr>
                      } @empty {
                        <tr>
                          <td colspan="7" class="text-center text-muted py-4">No pending orders.</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
